export default __webpack_public_path__ + "static/media/0458fedd-75f7-4aee-a0f1-8efb1fd455b4.e6df7bbf.jpg";